import { UserRoleEnum } from 'src/models/GalenData/UserRole.model';

function formatUserRole(role: UserRoleEnum): string {
  return role.replaceAll(/([a-z])([A-Z])/g, '$1 $2');
}

export default formatUserRole;
